import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=cba19f24&"
import script from "./expand.vue?vue&type=script&setup=true&lang=ts&"
export * from "./expand.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports